<template>
  <div style="height:100%" :style="{'min-height':'100%'}">
    <el-menu class="el-menu-vertical-demo hbb_menuBox" ref="menu" unique-opened="true">
      <el-submenu
        v-for="(item, index) in subMenuList"
        :key="index"
        :index="item.id"
        :data-parentid="item.id"
        :class="item.isSelect ? 'hbb_menuSelect': ''"
        @click.native="submenuSelect(item)"
      >
        <template slot="title">
          <span>{{item.title}}</span>
        </template>
        <el-menu-item-group v-for="(itm, inde) in item.children" :key="inde">
          <el-menu-item :index="itm.id">
            <span
              :class="itm.isSelect ? 'hbb_childrenSelect':'hbb_childrenM'"
              @click.stop="submenuSelectGroup(itm)"
            >{{itm.title}}</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subMenuList: [
        {
          title: "滤清器",
          id: 1,
          isSelect: true,
          children: [
            { title: "机油滤清器", id: 11, isSelect: true, brandId: 1 },
            { title: "机油滤清器", id: 12, isSelect: false, brandId: 1 },
            { title: "机油滤清器", id: 13, isSelect: false, brandId: 1 },
            { title: "机油滤清器", id: 14, isSelect: false, brandId: 1 },
            { title: "机油滤清器", id: 15, isSelect: false, brandId: 1 }
          ]
        },
        {
          title: "制动系统",
          id: 2,
          isSelect: false,
          children: [
            { title: "制动系统", id: 21, isSelect: true, brandId: 2 },
            { title: "制动系统", id: 22, isSelect: false, brandId: 2 },
            { title: "制动系统", id: 23, isSelect: false, brandId: 2 },
            { title: "制动系统", id: 24, isSelect: false, brandId: 2 },
            { title: "制动系统", id: 25, isSelect: false, brandId: 2 }
          ]
        },
        {
          title: "雨刮片",
          id: 3,
          isSelect: false,
          children: [
            { title: "雨刮片", id: 31, isSelect: true, brandId: 3 },
            { title: "雨刮片", id: 32, isSelect: false, brandId: 3 },
            { title: "雨刮片", id: 33, isSelect: false, brandId: 3 },
            { title: "雨刮片", id: 34, isSelect: false, brandId: 3 },
            { title: "雨刮片", id: 35, isSelect: false, brandId: 3 }
          ]
        },
        {
          title: "火花塞",
          id: 4,
          isSelect: false,
          children: [
            { title: "火花塞", id: 41, isSelect: true, brandId: 4 },
            { title: "火花塞", id: 42, isSelect: false, brandId: 4 },
            { title: "火花塞", id: 43, isSelect: false, brandId: 4 },
            { title: "火花塞", id: 44, isSelect: false, brandId: 4 },
            { title: "火花塞", id: 45, isSelect: false, brandId: 4 }
          ]
        },
        { title: "点火系统", id: 5, isSelect: false },
        { title: "发动机皮带", id: 6, isSelect: false }
      ]
    };
  },
  methods: {
    submenuSelect(val) {
      let currentId = val.id;
      this.subMenuList.forEach(x => {
        x.isSelect = false;
        if (x.id == currentId) {
          x.isSelect = true;
        }
        x.children.forEach(y => {
          y.isSelect = false;
        });
        x.children[0].isSelect = true;
      });
    },
    submenuSelectGroup(val) {
      let currentId = val.id;
      let currentBrandId = val.brandId;
      this.subMenuList.forEach(x => {
        x.isSelect = false;
        if (x.id == currentBrandId) {
          x.isSelect = true;
        }
        x.children.forEach(y => {
          y.isSelect = false;
          if (y.id == currentId) {
            y.isSelect = true;
          }
        });
      });
    }
  }
};
</script>

<style>
.hbb_menuBox {
  height: 100%;
  background: #f4f4f4;
}
.hbb_menuBox .el-menu {
  background: #f4f4f4;
}
.hbb_menuBox .el-submenu__icon-arrow {
  display: none;
}
.hbb_menuBox .el-menu-item-group__title {
  padding: 0;
}
.hbb_childrenSelect {
  width: 100%;
  background: #ffffff;
  display: flex;
  padding-left: 20px;
  border-radius: 20px 0 0 20px;
  font-size: 13px;
  color: #e74c3c;
}
.hbb_menuBox .el-submenu .el-menu-item {
  padding: 0 !important;
  padding-left: 20px !important;
  min-width: 100%;
}
.hbb_menuSelect {
  color: #282828;
  font-weight: bold;
}
.el-menu-item.is-active {
  color: #303133;
}
.hbb_childrenM {
  font-size: 13px;
  color: #999 !important;
  font-weight: normal !important;
  padding-left: 20px !important;
}
</style>